<template>
  <!-- 个人中心 -->
  <div class="a">
    <div class="da">
      <!-- 菜单 -->
      <div class="menu">
        <div class="menu-one" @click="fun1" :style="{ background: background1, color: color1 }">历史提交</div>
        <div class="menu-two" @click="fun2" :style="{ background: background2, color: color2 }">我的成绩</div>
        <div class="menu-four" v-if="isExperts" @click="fun4" :style="{ background: background4, color: color4 }">科学专区
        </div>
        <div class="menu-five" @click="fun5" :style="{ background: background5, color: color5 }">我的成就</div>
        <div class="menu-six" v-if="isExperts" @click="fun6" :style="{ background: background6, color: color6 }">异常专区
        </div>
      </div>
      <!-- 内容 -->
      <div class="conten">
        <!-- 历史提交 -->
        <div v-show="show">
          <div class="show" v-show="is" v-loading="loading2">

            <el-button @click="shut" type="info"
              style="width:30px;height:30px; position: absolute;left:48%;top:40px;border-radius:5px;"><i
                style="position: absolute;right:13px;bottom:6px" class="el-icon-close"></i></el-button>

            <div class="demo-image__preview">
              <div v-for="(item, index) in srcList" :key="index">
                <el-image style="width: 100px; height: 100px;margin:10px" :src="item" :preview-src-list="srcList">
                </el-image>
              </div>
            </div>

          </div>

          <div style="height:950px">
            <div class="block">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="curPage" :page-size="pageSize" :total="total" layout="prev, pager, next, jumper">
              </el-pagination>
            </div>

            <el-table :data="tableData" v-loading="loading" style="width: 100%;height:100%;">

              <el-table-column prop="rowId" label="编号">
              </el-table-column>

              <el-table-column prop="classTime" label="分类时间">
              </el-table-column>

              <el-table-column prop="classInfo" label="异常图片 ID" :formatter="transformData1">
              </el-table-column>

              <el-table-column prop="" label="查看异常图片">
                <template slot-scope="scope">
                  <el-button type="text" size="medium" @click="examine(scope.row.classInfo.class3)">点击查看图片</el-button>
                </template>
              </el-table-column>

            </el-table>
          </div>
        </div>

        <!-- 我的成绩 -->
        <div v-show="show1" class="grades">
          <div class="hander"></div>
          <div class="conter" v-loading="loading1">
            <span>{{ this.userInfo.name }}您好，</span><br>
            <span>您分类总次数是：{{ this.userInfo.classifyTimes }}</span><br>
            <span>您分类总异常数是：{{ this.userInfo.classifyTotalIrr }}</span><br>
            <span>您的平均分类完整率是：{{ this.rateComplete1 }}</span><br>
            <span>您的平均分类准确率是：{{ this.rateAcc1 }}</span><br>
            <span>您的综合得分是：{{ this.ranking.score }}，总排名为：{{ this.ranking.rank }}</span><br>
            <b style="font-size:18px;font-style:italic; color:red">用户指标信息将在24小时后自动刷新</b>
          </div>
        </div>

        <!-- 科学专区 -->
        <div v-show="show4">
          <div class="science">
            <div class="science-left">
              <div class="span-one"><span>Ra:{{ showObj.show1 }}</span> </div>
              <div class="span-two"><span>Dec:{{ showObj.show2 }}</span> </div>
              <div class="img">
                <el-image style="width: 250px; height: 250px" :src="expertImg[0]">
                </el-image>

              </div>

              <div class="text">
                <iframe :src="expertImg[1]" frameborder="1"></iframe>
              </div>

              <div class="img-one">
                <!-- <img :src="expertImg[2]" alt=""> -->
              </div>
            </div>

            <div class="science-right">
              <div class="science-right-one"><span>模型预测该星系可能为: <br>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                    style="border: 3px solid gainsboro; padding-left: 15px;padding-right: 15px; color: deepskyblue">{{
                      showObj.show0 }}</span></span></div>

              <div class="science-right-two">
                <div> <span>模型预测正确的分值:</span></div>
                <div> <el-slider v-model="value1" :max="10" :marks="marks" style="width:100%;padding-left: 25%;"
                    show-input input-size="mini" :show-tooltip=false></el-slider>
                </div>
              </div>

              <div class="science-right-three">
                <div> <span>感兴趣的程度: </span></div>
                <div> <el-slider v-model="value2" :max="10" :marks="marks" style="width:100%;padding-left: 25%;"
                    show-input input-size="mini" :show-tooltip=false></el-slider>
                </div>
              </div>

              <div class="science-right-four">
                是否是其他类别:
                <el-radio v-model="radio" :label=true>是</el-radio>
                <el-radio v-model="radio" :label=false>否</el-radio>
              </div>

              <div class="science-right-five">
                可能的类别：
                <el-select :disabled="!radio" v-model="value3" multiple placeholder="请选择" collapse-tags
                  style="width:85%;">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.label">
                  </el-option>
                </el-select>

              </div>

              <div class="science-right-six">
                原因：
                <div>
                  <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea"
                    :autosize="{ minRows: 2, maxRows: 2 }" resize="none" debounce>
                  </el-input>
                </div>
              </div>

              <div class="science-right-seven">
                <button :disabled="myDisabled" style="margin-right: 20px;" @click="nextTwo">上一张</button>
                <button style="margin-right: 20px;" @click="nextOne">下一张</button>
                <button @click="submit">提交</button>
              </div>
            </div>
          </div>

          <div class="expert" v-if="expertImg[2]">
            <img :src="expertImg[2]" alt="">
          </div>
        </div>

        <!-- 我的成就 -->
        <div v-show="show5" class="accomplishment">
          <div class="hander"><span>我的最新成就</span></div>
          <div class="conter">
            <p v-html="commendContent"></p>
          </div>
          <div class="footer">
            <button @click="getHTML" style="margin-right: 20px;color: rgb(51,182,51);">下载Html</button>
            <button @click="getCsv" style="color:rgb(30,156,255);">下载Csv</button>
          </div>
        </div>

        <!-- 异常专区 -->
        <div class="anomaly-Zone-big">
          <div v-show="show6" class="anomaly-Zone">
            <div class="grid-container" v-loading="loadingYC">
              <div class="grid-item" v-for="(item, index) in items" :key="index">
                <img :src="item.image" alt="">
                <div class="mask" :class="{ selected: item.selected }" @click="toggleSelection(index)">
                </div>
              </div>
            </div>
            <div class="button">
              <div class="button-null">
                <p>请您选择感兴趣的数据</p>
              </div>
              <div class="button-but">
                <!-- <el-button class="elbutton" plain type="primary" icon="el-icon-refresh-right" :disabled="isdisabled"
                  @click="flushed">{{
                    buttonText
                  }}</el-button> -->
                <el-button class="elbutton" plain type="primary" icon="el-icon-finished" :disabled="subdisabled"
                  @click="committed">提交</el-button>
                <!--  -->
              </div>
            </div>
          </div>
          <!-- 空状态 -->
          <div class="empty" v-show="empty"><el-empty description="暂无数据" /></div>
        </div>


      </div>
    </div>
    <!-- 回到顶部 -->
    <el-backtop :visibility-height="50" :bottom="120">
    </el-backtop>
  </div>
</template>

<script>

import { checkAPI, calculateAPI, getUserInfoAPI, getPageInfoAPI, findPicAPI, expertImgAPI, expertAPI, TextAPI, expertImg2API, expertCheckAPI, rankingAPI, getAnomalousImagesAPI, subAnomalousImagesAPI } from '@/API'
import axios from "axios";
import { saveAs } from 'file-saver';
export default {
  data () {
    return {
      //异常加载
      loadingYC: true,
      //是否可以点击刷新按钮
      isdisabled: false,
      //是否可以刷新
      isDisabled: false,

      subdisabled: false,
      countdown: 10, // 倒计时时间，单位为秒  
      timer: null,   // 定时器  
      //异常专区网格
      items: Array.from({ length: 12 }, () => ({ selected: true, image: '' })),
      imagePaths: [
        // require('../assets/1.jpg'),
        // require('../assets/1.jpg'),
        // require('../assets/1.jpg'),
        // require('../assets/1.jpg'),
        // require('../assets/1.jpg'),
        // require('../assets/1.jpg'),
        // require('../assets/1.jpg'),
        // require('../assets/1.jpg'),
        // require('../assets/1.jpg'),
        // require('../assets/1.jpg'),
        // require('../assets/1.jpg'),
        // require('../assets/1.jpg'),
      ],
      disabled: false,
      // 上一张按钮状态
      myDisabled: true,
      // 滑块刻度
      marks: {
        0: '0',
        5: '5',
        10: '10'
      },
      is: false,
      iss: false,
      // 当前页码
      curPage: 1,
      // 数据条数
      pageSize: 10,
      // 总条数
      total: 0,
      tableData: [],
      Data: [],

      background1: 'white',
      background2: '',
      background4: '',
      background5: '',
      background6: '',
      // 默认字体蓝色
      color1: 'rgb(64,158,255)',
      color2: 'rgb(144,157,153)',
      color4: 'rgb(144,157,153)',
      color5: 'rgb(144,157,153)',
      color6: 'rgb(144,157,153)',
      // 控制历史提交显示隐藏
      show: true,
      // 控制成绩显示隐藏
      show1: false,
      // 控制科学专区显示隐藏
      show4: false,
      // 控制我的成就显示隐藏
      show5: false,
      // 控制异常专区显示隐藏
      show6: false,
      //空状态显示隐藏
      empty: false,
      // 用户名字
      userInfo: {
        name: '亲爱的用户',
        // 分类总次数
        classifyTimes: 0,
        //分类总异常数
        classifyTotalIrr: 0,
        // 平均分类完整率
        rateComplete: 0.0,
        //  平均分类准确率
        rateAcc: 0.0
      },
      rateComplete1: '',
      rateAcc1: '',
      // 表格延迟加载
      loading: true,
      loading1: true,
      loading2: true,
      // 历史提交预览大图的路径
      srcList: [],
      // 是否正在请求中历史
      isRequesting: false,
      // 是否正在请求中
      isRequesting1: false,
      // 是否正在请求中科学
      isRequesting2: false,
      // 是否正在请求中我的成就
      isRequesting3: false,
      // 是否正在请求中异常专区
      isRequesting4: false,
      // expertImg
      expertImg: [],
      // 网络分类进度条默认值
      value1: 0,
      // 感兴趣进度条默认值
      value2: 0,
      radio: true,
      // 原因输入的内容
      textarea: '',
      // 类别选择数组
      options: [{
        value: '选项1',
        label: 'Low Surface Brightness'
      }, {
        value: '选项2',
        label: 'Merger'
      }, {
        value: '选项3',
        label: 'Star'
      }, {
        value: '选项4',
        label: 'Strong Gravitational Lens'
      }, {
        value: '选项5',
        label: 'Active Galaxy Nucleus'
      }, {
        value: '选项6',
        label: 'Active Galaxy Nucleus Candidate'
      }, {
        value: '选项7',
        label: 'BL Lac'
      }, {
        value: '选项8',
        label: 'Blue Object'
      }, {
        value: '选项9',
        label: 'Brightest Galaxy in a Cluster (BCG)'
      }, {
        value: '选项10',
        label: 'Cluster of Galaxies'
      },
      {
        value: '选项11',
        label: 'Emission-line galaxy'
      },
      {
        value: '选项12',
        label: 'Far-IR source '
      },
      {
        value: '选项13',
        label: 'Galaxy in Pair of Galaxies'
      },
      {
        value: '选项14',
        label: 'Galaxy towards a Cluster of Galaxies'
      },
      {
        value: '选项15',
        label: 'Galaxy towards a Group of Galaxies'
      },
      {
        value: '选项16',
        label: 'High Proper Motion Star'
      },
      {
        value: '选项17',
        label: 'HII Galaxy'
      },
      {
        value: '选项18',
        label: 'Infra-Red Source'
      },
      {
        value: '选项19',
        label: 'Interacting Galaxies'
      },
      {
        value: '选项20',
        label: 'LINER-type Active Galaxy Nucleus'
      },
      {
        value: '选项21',
        label: 'Low-mass Star'
      },
      {
        value: '选项22',
        label: 'Quasar'
      },
      {
        value: '选项23',
        label: 'Radio Galaxy'
      },
      {
        value: '选项24',
        label: 'Radio Source'
      },
      {
        value: '选项25',
        label: 'Red Giant Branch star'
      },
      {
        value: '选项26',
        label: 'Seyfert 1 Galaxy'
      },
      {
        value: '选项27',
        label: 'Seyfert 2 Galaxy'
      },
      {
        value: '选项28',
        label: 'Seyfert Galaxy'
      },
      {
        value: '选项29',
        label: 'White Dwarf Candidate'
      },],
      // 选择类别的数组
      value3: [],
      // 判断专家模块显示隐藏
      // todo
      isExperts: false,
      // 专家内容
      showObj: {
        show0: '',
        show1: '',
        show2: '',
      },
      exportInfo: {
        // 图片文件名后缀
        picRaDec: '',
        score: 0,
        extend: 0,
        possibleClass: '',
        reason: ''
      },
      // 我的成就txt文件渲染
      txt: '',
      //判断专家是否标注过
      flag: null,
      //
      ranking: {},
      //图片id
      picIdList: [],
      //返回图片数据
      imageNum: []
    }
  },
  created () {
    this.check()
    this.isExpert()
    this.fen()
    this.calculate()
  },
  beforeDestroy () {
    // 组件销毁前清除定时器  
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  //计算属性
  computed: {
    commendContent () {
      //this.txt是后端传回来的文本数据，就是要对这个数据进行处理
      let arr = this.txt.split("");
      return arr.map((item) => {
        return item === "\n" ? "<br>" : item
      }).join("")
    },
    buttonText () {
      return this.countdown < 10 ? `${this.countdown}秒后可刷新` : '刷新';
    },
  },
  methods: {
    //异常专区获取图片
    async fetchData () {
      this.imagePaths = []
      const res = await getAnomalousImagesAPI({
        num: 12
      })
      if (res.data.data == null) {
        this.subdisabled = true
        this.show6 = false
        this.empty = true
        this.$message({
          message: `${res.data.message}`,
          type: 'warning'
        });
        return
      }
      if (res.data.code == 1) {
        this.loadingYC = false
      }
      this.subdisabled = false
      this.show6 = true
      this.empty = false
      for (const item of res.data.data) {
        this.imagePaths.push(item)
      }
      this.imageNum = res.data.data
      // 更新 items 数组中的每个对象，添加图片路径
      this.items = this.items.map((item, index) => ({
        ...item,
        image: 'https://nadc.china-vo.org/galaxycircus/data' + this.imagePaths[index]
      }));
    },
    //异常专区刷新倒计时
    // startCountdown () {
    //   if (this.isdisabled == false) {
    //     this.isdisabled = true
    //     this.timer = setInterval(() => {
    //       if (this.countdown <= 0) {
    //         clearInterval(this.timer);
    //         this.isdisabled = false;
    //         this.isDisabled = false
    //         this.countdown = 10;
    //       } else {
    //         this.countdown -= 1;
    //       }
    //     }, 1000)
    //   }
    // },
    // //异常专区刷新
    // async flushed () {
    //   if (this.isDisabled) return;
    //   this.imagePaths = []
    //   const res = await getAnomalousImagesAPI({
    //     num: 12
    //   })
    //   if (res.data.data == null) {
    //     this.subdisabled = true
    //     this.$message({
    //       message: `${res.data.message}`,
    //       type: 'warning'
    //     });
    //     return
    //   }
    //   //提交按钮是否可以使用
    //   this.subdisabled = false
    //   for (const item of res.data.data) {
    //     this.imagePaths.push(item.picPath)
    //   }
    //   this.imageNum = res.data.data
    //   // 更新 items 数组中的每个对象，添加图片路径
    //   this.items = this.items.map((item, index) => ({
    //     ...item,
    //     image: 'https://nadc.china-vo.org/galaxycircus/' + this.imagePaths[index]
    //   }));
    //   if (res.data.code == 1) {
    //     this.$message({
    //       message: '刷新成功',
    //       type: 'success'
    //     });
    //     this.picIdList = []
    //     for (const element of this.items) {
    //       element.selected = true
    //     }
    //   } else {
    //     this.$message.error('出错了请稍后重试');
    //   }
    //   this.isDisabled = true;
    //   this.startCountdown();
    // },
    //异常专区提交
    async committed () {
      this.loadingYC = true
      const res = await subAnomalousImagesAPI({
        picIds: this.picIdList.join(","),
        expertId: window.localStorage.getItem('umtId')
      })
      if (res.data.code == 1) {
        this.loadingYC = false
        this.$message({
          message: '提交成功',
          type: 'success'
        });
        this.picIdList = []
        for (const element of this.items) {
          element.selected = true
        }
        this.fetchData()
      }
    },
    //选择图片
    toggleSelection (index) {
      // this.items[index].selected = !this.items[index].selected;
      // if (this.items[index].selected == false) {
      //   if (!this.picIdList.includes(this.imageNum[index].id)) {
      //     this.picIdList.push(this.imageNum[index].id)
      //   }
      // } else {
      //   const picIndex = this.picIdList.indexOf(this.imageNum[index].id);
      //   if (picIndex !== -1) {
      //     this.picIdList.splice(picIndex, 1)
      //   }
      // }
      this.items[index].selected = !this.items[index].selected;
      if (this.items[index].selected == false) {
        this.picIdList.push(this.imageNum[index])
      } else {
        const picIndex = this.picIdList.indexOf(this.imageNum[index]);
        if (picIndex !== -1) {
          this.picIdList.splice(picIndex, 1)
        }
      }
    },
    // 显示图片
    examine (dataArr) {
      this.is = true
      this.findPicAPI(dataArr)
    },
    // 查看结果
    async findPicAPI (dataArr) {
      try {
        const res = await findPicAPI({
          class3Arr: dataArr.join()
        })
        if (res.data.code == 1) {
          this.loading2 = false
          this.srcList = res.data.data.map((item) => {
            return 'https://nadc.china-vo.org/galaxycircus/' + item
          })
        }
      } catch (error) {
        if (axios.isAxiosError(error) && error.code === 'ECONNABORTED') {
          // 处理请求超时的逻辑
          this.$alert("请求超时请重试", '提示', {
            confirmButtonText: '确定',
            type: 'error',
            showClose: false,
          });
        }
      }
    },

    // 科学专区内容
    async showExpertImg () {
      const { data: res } = await expertImgAPI({
        umtId: window.localStorage.getItem('umtId')
      });
      if (res.code == 1 && res.data.length == 2) {
        for (let i = 0; i < 2; i++) {
          if (res.data[i].endsWith(".jpg")) {
            this.expertImg[0] = 'https://nadc.china-vo.org/galaxycircus' + res.data[i]
            let str = res.data[i];
            let arr = str.split("/")[3].split("_");
            this.showObj.show0 = arr[0];
            this.showObj.show1 = arr[1];
            this.showObj.show2 = arr[2].substring(0, arr[2].lastIndexOf('.'));
          } else {
            this.expertImg[1] = 'https://nadc.china-vo.org/galaxycircus' + res.data[i]
          }
        }

      } else if (res.code == 1 && res.data.length == 3) {
        for (let i = 0; i < 3; i++) {
          if (res.data[i].endsWith(".jpg") && res.data[i].length > 20) {
            this.expertImg[0] = 'https://nadc.china-vo.org/galaxycircus' + res.data[i]
            let str = res.data[i];
            let arr = str.split("/")[3].split("_");
            this.showObj.show0 = arr[0];
            this.showObj.show1 = arr[1];
            this.showObj.show2 = arr[2].substring(0, arr[2].lastIndexOf('.'));
          } else if (res.data[i].endsWith(".txt")) {
            this.expertImg[1] = 'https://nadc.china-vo.org/galaxycircus' + res.data[i]
          } else {
            this.expertImg[2] = 'https://nadc.china-vo.org/galaxycircus' + res.data[i]
          }
        }
      } else {
        this.$alert(res.message, '提示', {
          type: 'warning',
          showClose: false
        })
      }
      this.isRequesting2 = true
    },

    // 上一张
    async showExpertImg2 () {
      const { data: res } = await expertImg2API({
        umtId: window.localStorage.getItem('umtId')
      });
      if (res.code == 1 && res.data.length == 2) {
        for (let i = 0; i < 2; i++) {
          if (res.data[i].endsWith(".jpg")) {
            this.expertImg[0] = 'https://nadc.china-vo.org/galaxycircus' + res.data[i]
            let str = res.data[i];
            let arr = str.split("/")[3].split("_");
            this.showObj.show0 = arr[0];
            this.showObj.show1 = arr[1];
            this.showObj.show2 = arr[2].substring(0, arr[2].lastIndexOf('.'));
          } else {
            this.expertImg[1] = 'https://nadc.china-vo.org/galaxycircus' + res.data[i]
          }
        }

      } else if (res.code == 1 && res.data.length == 3) {
        for (let i = 0; i < 3; i++) {
          if (res.data[i].endsWith(".jpg") && res.data[i].length > 20) {
            this.expertImg[0] = 'https://nadc.china-vo.org/galaxycircus' + res.data[i]
            let str = res.data[i];
            let arr = str.split("/")[3].split("_");
            this.showObj.show0 = arr[0];
            this.showObj.show1 = arr[1];
            this.showObj.show2 = arr[2].substring(0, arr[2].lastIndexOf('.'));
          } else if (res.data[i].endsWith(".txt")) {
            this.expertImg[1] = 'https://nadc.china-vo.org/galaxycircus' + res.data[i]
          } else {
            this.expertImg[2] = 'https://nadc.china-vo.org/galaxycircus' + res.data[i]
          }
        }
      } else {
        this.$alert(res.message, '提示', {
          type: 'warning',
          showClose: false
        })
      }
      this.isRequesting2 = true
    },
    //判断是否为专家
    async isExpert () {
      const { data: res } = await expertAPI({
        umtId: window.localStorage.getItem("umtId")
      })
      if (res.code == 1) {
        this.isExperts = true
      }
    },
    // 判断专家是否标注过
    async kexue () {
      const res = await expertCheckAPI({
        expertId: window.localStorage.getItem('umtId'),
        // todo
        picRaDec: this.showObj.show1 + '_' + this.showObj.show2
      })
      if (res.data.code == 1) {
        this.flag = true
        this.value1 = res.data.data.score
        this.value2 = res.data.data.extend
        this.value3 = res.data.data.possibleClass.split('-')
        this.textarea = res.data.data.reason
      } else {
        this.flag = false
      }
    },
    // 下一张
    nextOne () {
      this.clear()
      this.showExpertImg()
      setTimeout(() => {
        this.kexue()
      }, 500);
      this.myDisabled = false
    },
    // 上一张
    nextTwo () {
      this.clear()
      this.showExpertImg2()
      setTimeout(() => {
        this.kexue()
      }, 500);
    },
    // 提交结果
    async submit () {
      this.exportInfo.picRaDec = this.showObj.show1 + '_' + this.showObj.show2
      this.exportInfo.score = this.value1
      this.exportInfo.extend = this.value2
      this.exportInfo.possibleClass = this.value3.join('-')
      this.exportInfo.reason = this.textarea
      // TODO
      axios({
        method: 'post',
        baseURL: 'https://nadc.china-vo.org/galaxycircus',
        url: `/api/expert/info?flag=${this.flag}`,
        data: {
          picRaDec: this.exportInfo.picRaDec,
          expertId: window.localStorage.getItem("umtId"),
          score: this.exportInfo.score,
          extend: this.exportInfo.extend,
          possibleClass: this.exportInfo.possibleClass,
          reason: this.exportInfo.reason
        },
        headers: { 'Token-Circus': window.localStorage.getItem('Token-Circus') }
      }).then((res) => {
        this.$alert(res.data.message, '提示', {
          type: 'success',
          showClose: false
        })
        this.nextOne()
      })
    },
    // 清空专家选项内容
    clear () {
      this.expertImg = []
      this.value1 = 0
      this.value2 = 0
      this.value3 = []
      this.textarea = ''
    },

    // 我的成就txt文件
    async Text () {
      const { data: res } = await TextAPI({
        umtId: window.localStorage.getItem('umtId')
      })
      if (res.code == 0) {
        this.$alert(res.message, '提示', {
          type: "warning",
          showClose: false
        })
      } else {
        this.txt = res;
      }
    },
    // 我的成就html下载
    getHTML () {
      // window.location.href = 'https://nadc.china-vo.org/galaxycircus/api/users/download/2?umtId=' + localStorage.getItem('umtId');
      axios(
        {
          url: 'https://nadc.china-vo.org/galaxycircus/api/users/download/2?umtId=' + localStorage.getItem('umtId'),
          headers: { 'Token-Circus': window.localStorage.getItem("Token-Circus") }
        })
        .then(response => {
          console.log(response);
          const blob = new Blob([response.data], { type: 'text/html' });
          saveAs(blob, 'irr_know.html');

        })
        .catch(error => {
          console.error('下载HTML文件出错:', error);
        });

    },
    // 我的成就csv下载
    getCsv () {
      // window.location.href = 'https://nadc.china-vo.org/galaxycircus/api/users/download/3?umtId=' + localStorage.getItem('umtId');
      axios(
        {
          url: 'https://nadc.china-vo.org/galaxycircus/api/users/download/3?umtId=' + localStorage.getItem('umtId'),
          headers: { 'Token-Circus': window.localStorage.getItem("Token-Circus") }
        })
        .then(response => {
          console.log(response);
          const blob = new Blob([response.data], { type: 'text/csv' });
          saveAs(blob, 'irr_know.csv');

        })
        .catch(error => {
          console.error('下载HTML文件出错:', error);
        });

    },
    async getRanking () {
      const res = await rankingAPI({
        umtId: window.localStorage.getItem('umtId')
      })
      this.ranking = res.data.data
    },

    transformData1 (row) {
      if (row.classInfo.class3.length == 0) {
        return '无'
      } else {
        return row.classInfo.class3.join(",");
      }
    },
    fun1 () {
      this.background1 = "white"
      this.background2 = ""
      this.background4 = ""
      this.background5 = ""
      this.background6 = ""
      this.color1 = "rgb(64,158,255)"
      this.color2 = "rgb(144,157,153)"
      this.color4 = "rgb(144,157,153)"
      this.color5 = "rgb(144,157,153)"
      this.color6 = "rgb(144,157,153)"
      this.show = true
      this.show1 = false
      this.show4 = false
      this.show5 = false
      this.show6 = false
      this.empty = false
      this.isRequesting4 = false
    },
    fun2 () {
      this.background1 = ""
      this.background2 = "white"
      this.background4 = ""
      this.background5 = ""
      this.background6 = ""
      this.color1 = "rgb(144,157,153)"
      this.color2 = "rgb(64,158,255)"
      this.color4 = "rgb(144,157,153)"
      this.color5 = "rgb(144,157,153)"
      this.color6 = "rgb(144,157,153)"
      this.show = false
      this.show1 = true

      this.show4 = false
      this.show5 = false
      this.show6 = false
      this.empty = false
      this.isRequesting4 = false
      if (this.isRequesting) {
        return
      } else {
        this.isRequesting = true
        this.getUserInfo()
        this.getRanking()
      }
    },
    fun4 () {
      this.background1 = ""
      this.background2 = ""

      this.background4 = "white"
      this.background5 = ""
      this.background6 = ""
      this.color1 = "rgb(144,157,153)"
      this.color2 = "rgb(144,157,153)"

      this.color4 = "rgb(64,158,255)"
      this.color5 = "rgb(144,157,153)"
      this.color6 = "rgb(144,157,153)"
      this.show = false
      this.show1 = false

      this.show4 = true
      this.show5 = false
      this.show6 = false
      this.empty = false
      this.isRequesting4 = false
      if (this.isRequesting2) {
        return
      } else {
        this.isRequesting2 = true
        this.showExpertImg()
        setTimeout(() => {
          this.kexue()
        }, 500);
      }
    },
    fun5 () {
      this.background1 = ""
      this.background2 = ""
      this.background4 = ""
      this.background5 = "white"
      this.background6 = ""
      this.color1 = "rgb(144,157,153)"
      this.color2 = "rgb(144,157,153)"

      this.color4 = "rgb(144,157,153)"
      this.color5 = "rgb(64,158,255)"
      this.color6 = "rgb(144,157,153)"
      this.show = false
      this.show1 = false

      this.show4 = false
      this.show5 = true
      this.show6 = false
      this.empty = false
      this.isRequesting4 = false
      if (this.isRequesting3) {
        return
      } else {
        this.isRequesting3 = true
        this.Text()
      }
    },
    fun6 () {
      this.background1 = ""
      this.background2 = ""
      this.background4 = ""
      this.background5 = ""
      this.background6 = "white"
      this.color1 = "rgb(144,157,153)"
      this.color2 = "rgb(144,157,153)"
      this.color4 = "rgb(144,157,153)"
      this.color5 = "rgb(144,157,153)"
      this.color6 = "rgb(64,158,255)"
      this.show = false
      this.show1 = false
      this.show4 = false
      this.show5 = false
      // this.show6 = true
      if (this.isRequesting4) {
        return
      } else {
        this.isRequesting4 = true
        this.fetchData()
      }
    },

    //TODO
    //换页
    handleSizeChange () {
      this.fen()
    },
    handleCurrentChange () {
      this.fen()
    },
    // 校验接口
    async check () {
      const res = await checkAPI({})
      if (res.data.code == 1) {
        this.$router.push("/home/my")
        localStorage.setItem("umtId", res.data.data.toString())
      } else {
        // window.location.href = 'https://oauth.china-vo.org/oauth/authorize?response_type=code&client_id=nhjG5SWNJ1xiFuxTjK5LWWj1&redirect_uri=https%3A//nadc.china-vo.org/galaxycircus/api/callback1&scope=profile'
      }
    },
    shut () {
      this.is = false
      this.srcList = []
    },
    // 更新用户指标
    async calculate () {
      const res = await calculateAPI({
        umtId: localStorage.getItem("umtId")
      })
    },
    // 获取指标数据
    async getUserInfo () {
      try {
        const res = await getUserInfoAPI({
          umtId: localStorage.getItem("umtId")
        })
        if (res.data.code == 1) {
          this.loading1 = false
          this.userInfo = res.data.data
          this.rateComplete1 = (this.userInfo.rateComplete * 100).toFixed(2) + '%'
          this.rateAcc1 = (this.userInfo.rateAcc * 100).toFixed(2) + '%'
          this.isRequesting = true
        }
      } catch (error) {
        if (axios.isAxiosError(error) && error.code === 'ECONNABORTED') {
          // 处理请求超时的逻辑
          this.$alert("请求超时请重试", '提示', {
            confirmButtonText: '确定',
            type: 'error',
            showClose: false,
          });
          this.isRequesting = true
        }
      }

    },
    // 分页的接口
    async fen () {
      try {
        const res = await getPageInfoAPI({
          curPage: this.curPage,
          pageSize: this.pageSize,
          umtId: localStorage.getItem("umtId")
        })
        if (res.data.code == 1) {
          this.loading = false
          this.tableData = res.data.data.records;
          this.curPage = res.data.data.current;
          this.pageSize = res.data.data.size;
          this.total = res.data.data.total;
        }
      } catch (error) {
        if (axios.isAxiosError(error) && error.code === 'ECONNABORTED') {
          // 处理请求超时的逻辑
          this.$alert("请求超时请重试", '提示', {
            confirmButtonText: '确定',
            type: 'error',
            showClose: false,
          });
        }
      }

    },
  }
}
</script>

<style lang="scss" scoped>
.a {
  overflow: hidden;
}

//异常专区
.anomaly-Zone-big {
  width: 100%;
  height: 100%;
  padding-top: 1px;
}

.anomaly-Zone {
  width: 55%;
  height: 60%;

  margin: 70px auto;

  .grid-container {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(4, 24.25%);
    grid-template-rows: repeat(3, 32.6%);
    gap: 1%;

    .grid-item {
      position: relative;
      width: 100%;
      height: 100%;
      background-color: #fff;
      border: 1px solid #ccc;
      border-radius: 5px;
      overflow: hidden;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);

      img {
        width: 100%;
        height: 100%;
      }
    }

    .mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(135, 206, 250, 0.4);
      transition: opacity 0.3s;
      cursor: pointer;
    }

    .mask.selected {
      opacity: 0;
      /* 隐藏遮罩层 */
    }
  }

  .button {
    width: 100%;
    display: flex;

    .button-but {
      margin-top: 10px;
      width: 50%;
      display: flex;
      justify-content: right;
      padding-right: 1%;

      .elbutton {
        width: 48%;
        text-align: center;
        font-size: 18px;

      }

      .elbutton:nth-child(2) {
        margin-right: 5px;
      }
    }

    .button-null {
      width: 50%;
      display: flex;
      justify-content: left;
      align-items: center;
      color: red;
    }
  }

}

//成绩
.grades {
  width: 70%;
  height: 50%;
  margin: 70px auto;
}

.hander {
  width: 100%;
  height: 15%;
  background-color: rgb(44, 62, 80);
}

.conter {
  width: 100%;
  height: 100%;
  background-color: rgb(255, 255, 255);
  text-align: center;
  color: black;
  box-shadow: #ccc 0px 0px 10px;
  line-height: 60px;

  span {
    font-size: 32px;
  }
}

//成就
.accomplishment {
  width: 70%;
  height: 55%;
  margin: 70px auto;

  .hander {
    width: 100%;
    height: 15%;
    background-color: rgb(44, 62, 80);
    box-shadow: #ccc 0px 0px 10px;
    text-align: center;
    line-height: 70px;

  }

  .conter {
    width: 100%;
    height: 100%;
    background-color: rgb(255, 255, 255);
    text-align: center;
    color: black;
    box-shadow: #ccc 0px 0px 10px;
    line-height: 60px;
    padding: 50px;
    white-space: pre-line;

    p {
      text-align: left;
    }
  }

  .footer {
    width: 100%;
    height: 10%;
    display: flex;
    justify-content: right;

    button {
      width: 100px;
      height: 50px;
      font-size: 18px;
      margin-top: 20px;
      font-weight: 700;
      cursor: pointer;
    }
  }
}

// 最大的盒子
.da {
  display: flex;
  width: 100%;
  height: 800px;
  background-color: white;
}

//菜单
.menu {
  width: 10%;
  height: 100%;
  background-color: rgb(245, 247, 250);
}

.menu-one {
  width: 100%;
  height: 40px;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

.menu-two {
  width: 100%;
  height: 40px;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}


.menu-four {
  width: 100%;
  height: 40px;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

.menu-five {
  width: 100%;
  height: 40px;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

.menu-six {
  width: 100%;
  height: 40px;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

.conten {
  width: 90%;
  height: 100%;
  background-color: white;
}

.a {
  width: 100%;
  height: 100%;
  color: white;
  position: relative;
}

.button {
  width: 120px;
  text-align: center;
  margin-left: 5px;
}

img {
  width: 100px;
  height: 100px;
}

.show {
  background-color: rgba(255, 255, 255, 0.9);
  position: absolute;
  z-index: 99;
  width: 90%;
  height: 100%;

  .show-one {
    img {
      position: absolute;
      left: 8%;
      top: 17%;
      width: 310px;
      height: 310px;
    }
  }
}

.block {
  padding-top: 10px;
  background-color: white;
}

.jg {
  position: absolute;
  z-index: 10;
  background-color: rgba(127, 127, 127, 0.5);
  width: 90%;
  height: 100%;

  // padding-bottom: 15px;
  .jg-one {
    position: relative;
    left: 0.5%;
    top: 20%;
  }
}

.demo-image__preview {
  width: 60%;
  height: 520px;
  margin-left: 20%;
  margin-top: 100px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

::v-deep .el-table .el-table__cell {
  text-align: center;
}

.image {
  background-color: rgba(127, 127, 127, 0.5);
  position: absolute;
  z-index: 99;
  width: 90%;
  height: 100%;

  .image-one {
    position: absolute;
    left: 35%;
    top: 10%;
    width: 370px;
    height: 450px;
    background-color: white;
    text-align: center;
    line-height: 70px;
    font-size: 24px;

    img {
      position: absolute;
      left: 8%;
      top: 17%;
      width: 310px;
      height: 310px;
    }
  }
}



.science {
  width: 1000px;
  height: 580px;
  background-color: rgb(245, 247, 250);
  margin: 40px auto;
  display: flex;
  color: black;


  span {
    font-size: 20px;
  }

  .span-one {
    padding-right: 130px;
    margin-top: 30px;

    width: 62%;
  }

  .span-two {
    width: 62%;
    padding-right: 130px;
    margin-top: 10px;

  }

  .science-left {
    width: 40%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;

    .img {
      width: 250px;
      height: 250px;
      margin-top: 20px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .img-one {
      width: 400px;
      height: 150px;
    }

    .text {
      width: 250px;
      height: 100px;
      margin-top: 45px;


      iframe {
        width: 100%;
        height: 100%;
      }
    }
  }


  .science-right {
    width: 55%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin-right: 5%;

    .science-right-one {
      width: 100%;
      height: 50px;
      padding: 10px;
      line-height: 35px;
    }

    .science-right-two {
      width: 100%;
      height: 50px;
      padding: 10px;
      margin-top: 30px;
    }

    .science-right-three {
      width: 100%;
      height: 50px;
      padding: 10px;
      margin-top: 30px;
    }

    .science-right-four {
      width: 100%;
      height: 50px;
      padding: 10px;
      margin-top: 40px
    }

    .science-right-five {
      width: 100%;
      height: 50px;
      padding: 10px;
      line-height: 30px;
      margin-bottom: 30px;
    }

    .science-right-six {
      width: 100%;
      height: 50px;
      padding: 10px;
      line-height: 30px;
      margin-bottom: 30px;
    }

    .science-right-seven {
      width: 100%;
      height: 50px;
      padding: 10px;
      display: flex;
      justify-content: right;
      align-items: center;
      margin-top: 17px;

      button {
        width: 90px;
        font-size: 16px;
        font-weight: 700;
      }
    }
  }
}

.expert {
  width: 500px;
  height: 300px;
  margin-left: 50%;
  transform: translateX(-50%);

  img {
    width: 100%;
    height: 100%;
  }
}
</style>